import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UnlinkCardRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UnlinkCardResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const unlinkCard = (request: UnlinkCardRequest, options?: CashRequestOptions) =>
  post<UnlinkCardRequest, UnlinkCardResponse>('/2.0/cash/unlink-card', request, { ...options, rejectOnError: true })
